import type { ConcreteDataType } from '@thinkalpha/language-services';
import type { OutputColumnWithMetadata } from '@thinkalpha/platform-ws-client/contracts/table.js';
import type { FormattableColumn } from '@thinkalpha/ui-types/contracts/display/settings';

export function getValidationColumnDisplayName(column: OutputColumnWithMetadata): string {
    if (column.validationFormula) {
        return column.validationFormula;
    }

    if ('formula' in column && typeof column.formula === 'string') {
        return column.formula;
    }

    if ('indicator' in column) {
        const indicator = column.indicator;
        if (typeof indicator === 'object' && indicator !== null && 'formula' in indicator) {
            const formula = indicator.formula;
            if (typeof formula === 'object' && formula !== null && 'formula' in formula) {
                const formulaText = formula.formula;
                if (typeof formulaText === 'string') {
                    return formulaText;
                }
            }
        }
    }

    return column.matchSlug ?? column.id;
}

export function validationColumnToFormattableColumn(column: OutputColumnWithMetadata): FormattableColumn {
    return {
        dataType: column.dataType as ConcreteDataType,
        displaySettings: [],
        id: column.id,
        name: getValidationColumnDisplayName(column),
        unit: typeof column.unit === 'string' ? column.unit : null,
        visible: true,
    };
}
